// 热更新HTML页面
if (process.env.NODE_ENV !== 'production') {
  require('html-loader!./index.html')
}

const network = $('#network')
network.find('.tabs_ul .item').on('click', function () {
  const self = $(this)
  const index = self.index() + 1
  switch (index) {
    case 1:
      location.href = '/WechatH5Class'
      break
    case 2:
      location.href = '/PCClass'
      break
    case 3:
      location.href = '/miniProgramClass'
      break
  }
})

const type = terminalnetwork
const item = network.find(`.tabs_ul .item${type}`)
item.css({ color: '#1B9D97' }).siblings().css({ color: '' })
network
  .find(`.show-content:eq(${type - 1})`)
  .show()
  .siblings()
  .hide()

// network.find('.reg_bt').on('click', function () {
//   const num = network.find('.input_number').val()
//   let phone =
//     num.length > 0 ? `?phone=${network.find('.input_number').val()}` : ''
//   window.open($.getEnv().teacherUrl+'?t=register&source=1' + phone)
// })
